export const environment = {
    production: true,

    name: 'Booking | GOV',
    version: '0.0.1',

    frontend: 'https://booking.pvaigaiou.gov.gr',
    backend: 'https://booking.open1.eu/api',

    config: {
        organization: 'Περιφέρεια Βορείου Αιγαίου',
        govUid: 'pvaigaiou',
        logo: 'pvaigaiou-logo.png',
        website: 'https://www.pvaigaiou.gov.gr/',
        termsOfService: 'assets/terms/pvaigaiou-terms.pdf',
        homepageTitle: 'Ψηφιακό ραντεβού για τις Διευθύνσεις Μεταφορών και Επικοινωνιών της Περιφέρειας Βορείου Αιγαιίου',
        links: [
            // { label: 'Όροι Χρήσης', link: 'assets/terms/pvaigaiou-terms.pdf' },
            { label: 'Απαραίτητα Δικαιολογητικά', link: 'https://www.yme.gr/odigos-politi' },
        ],
    },

    gsis: {
        baseUrl: 'https://oauth2.gsis.gr/oauth2server',
        redirectUrl: 'https://booking.pvaigaiou.gov.gr/login/callback',
        authorize: '/oauth/authorize',
        clientId: 'LY7TIC29253',
        scope: 'read',
        responseType: 'code',
        approval: 'auto',
    },
};
